import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { notifyError } from '../Notification';
import AddStoreModal from './modals/stores/AddStoreModal';
import DeleteStoreModal from './modals/stores/DeleteStoreModal';
import EditStoreModal from './modals/stores/EditStoreModal';
import ViewStoreModal from './modals/stores/ViewStoreModal';
import GenericModal from '../genericModal/GenericModal';
import './superAdminStore.css';
import { useSelector, useDispatch } from 'react-redux';
import { fetchStores } from '../../redux/storesSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEdit, faTrash, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';





const SuperAdminBusinessStoreControl = () => {
  const selectedBusinessId = localStorage.getItem('selectedBusinessId');
  const { items: stores, loading, error } = useSelector((state) => state.stores);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [hovered, setHovered] = useState(false);

  // arrange store data in ascending order

  const dispatch = useDispatch();

  useEffect(() => {
    if (selectedBusinessId) {
      dispatch(fetchStores(selectedBusinessId));
    }
  }, [selectedBusinessId, dispatch]);

  const handleAddModalShow = () => setShowAddModal(true);
  const handleAddModalClose = () => setShowAddModal(false);
  
  const handleDeleteModalShow = (store) => {
    if (!store) return notifyError('Select a store to delete');
    setSelectedStore(store);
    setShowDeleteModal(true);
  };
  const handleDeleteModalClose = () => setShowDeleteModal(false);

  const handleEditModalShow = (store) => {
    if (!store) return notifyError('Select a store to edit');
    setSelectedStore(store);
    setShowEditModal(true);
  }

  const handleViewModalShow = (store) => {
    if (!store) return notifyError('Select a store to view');
    setSelectedStore(store);
    setShowViewModal(true);
  }
  const handleViewModalClose = () => setShowViewModal(false);
  const handleEditModalClose = () => setShowEditModal(false);
  

  return (
    <div className='super-admin-store-container'>
      <div className='super-admin-store-header'>
        <button className='super-admin-store-btn-add' onClick={handleAddModalShow}>
          &#43;
        </button>
        <span className='super-admin-store-total-label'>
          Total stores: 
            <span className='super-admin-store-total-value'>
              {stores.length}
            </span>
        </span>
      </div>
      <div className='super-admin-store-table-container'>
      <table className='super-admin-store-table'>
        <thead className='super-admin-store-table-header'>
          <tr>
            <th>Business</th>
            <th>Stores</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody className='super-admin-store-table-body'>
          {stores?.length ? (
            stores.map((store, index) => (
              <tr key={index}>
                <td>{localStorage.getItem('selectedBusinessName')}</td>
                <td>{store.name}</td>
                <td>
                  <div className='super-admin-store-btns-container'>

                  <button
                    className='super-admin-store-btn-view'
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    onClick={() => handleViewModalShow(store)}
                  >
                    <FontAwesomeIcon icon={hovered ? faEye : faEyeSlash} />
                  </button>

                    <button
                      className='super-admin-store-btn-edit'
                      onClick={() => handleEditModalShow(store)}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                    
                    <button
                      className='super-admin-store-btn-delete'
                      onClick={() => handleDeleteModalShow(store)}
                    >
                     <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td>{selectedBusinessId}</td>
              <td>No stores found</td>
              <td>
                <button className='super-admin-store-btn' onClick={handleAddModalShow}>
                  Add
                </button>
              </td>
            </tr>
          )}
        </tbody>
      </table>
      </div>

      {/* Add Store Modal */}
      <GenericModal
        show={showAddModal}
        onClose={handleAddModalClose}
        size='lg'
        header={
          <div className="custom-modal-header">
            <div className="modern-preview-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-plus-circle-fill" viewBox="0 0 16 16">
                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z"/>
              </svg>
            </div>
            <div className="deck-modal-header-content">
              <h1 className='slide1-main-title'>Add a Store</h1>
            </div>
          </div>
        }
        body={<AddStoreModal business_id={selectedBusinessId} onClose={handleAddModalClose} />}
      />

      {/* Delete Store Modal */}
      <GenericModal
        show={showDeleteModal}
        onClose={handleDeleteModalClose}
        header={
          <div className="custom-modal-header">
            <div className="modern-preview-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-trash-fill" viewBox="0 0 16 16">
                <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z"/>
              </svg>
            </div>
            <div className="deck-modal-header-content">
              <h1 className='slide1-main-title'>Delete Store</h1>
            </div>
          </div>
        }
        body={<DeleteStoreModal store={selectedStore} onClose={handleDeleteModalClose} />}
      />

      {/* Edit Store Modal */}
      <GenericModal
        show={showEditModal}
        onClose={handleEditModalClose}
        size='lg'
        header={
          <div className="custom-modal-header">
            <div className="modern-preview-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-pencil-square" viewBox="0 0 16 16">
                <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.24a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
              </svg>
            </div>
            <div className="deck-modal-header-content">
              <h1 className='slide1-main-title'>Edit Store</h1>
            </div>
          </div>
        }
        body={<EditStoreModal store={selectedStore} onClose={handleEditModalClose} />}
      />

      {/* View Store Modal */}
      <GenericModal
        show={showViewModal}
        onClose={handleViewModalClose}
        size='lg'
        header={
          <div className="custom-modal-header">
            <div className="modern-preview-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-eye-fill" viewBox="0 0 16 16">
                <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
              </svg>
            </div>
            <div className="deck-modal-header-content">
              <h1 className='slide1-main-title'>View Your Store</h1>
            </div>
          </div>
        }
        body={<ViewStoreModal store={selectedStore} onClose={handleViewModalClose} />}
      />

    </div>
  );
};

export default SuperAdminBusinessStoreControl;
